export default __webpack_public_path__ + "static/media/8.933acc80.webp";